const SHAPES = ["circle", "square"];
const TRIGGER_TYPES = ["mask", "button"];
export { SHAPES, TRIGGER_TYPES };
